/*
    Component -> GeneriInterstitial
    Component to create diferrents interstitials (commercial, fioc, legal)
    We include here differents function to render the modal, and functions to
    close, accept, denied, etc for all the interstitials
    We connect with the generic actions and the generic reducer.

    1. COMMERCIAL functions
        - setCommercialModalState
        - onHandleImageClick
        - handleRedirectCommercialUrl
        - onHandleCloseCommercialInterstitial
        - onHandleOptOutCommercialInterstitial
        - buildCommercial

    2. LEGAL functions
        - setLegalModalState
        - handleAcceptLegal
        - handleCancelLegal
        - onCheckLegal
        - buildLegal

    3. FIOC functions
      - getUtagPageNameForFioc
      - getUTagCustomTagDataForFioc
      - handleCancelFioc
      - handleAcceptFioc
      - buildFioc

    4. Render functions
      - buildModalInterstitial
      - checkDevice
      - resize
*/

require('./interstitialGeneric.scss');

// @core
const React = require('react');
const PropTypes = require('prop-types');
const ReactDOM = require('react-dom');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const moment = require('moment');
const trim = require('lodash/string/trim');
const get = require('lodash/object/get');

// @helpers
const {
    buildTemplateCommercialA,
    buildTemplateCommercialB,
    buildTemplateCommercialC,
    buildTemplateCommercialD,
    buildTemplateCommercialE,
    buildTemplateCommercialF,
    buildTemplateCommercialG,
    buildTemplateCommercialAdvance,
    updateTokenUserInterstitial,
    hasTokenInterstitial,
    generateTokenSessionInterstitial,
    compareTokenSessionInterstitial
} = require('utilities/genericInterstitialsHelper');
const {
    formatRedirectUrl,
    hasPrivateUrl,
    hasPublicUrl,
} = require('utilities/commercialAdsHelper');
const { toCamelCase } = require('utilities/stringHelper');
const { recordGdprClauseInteraction } = require('utilities/consentsHelper');

// @actions
const advancedInterstitialPromotionActions = require('actions/advancedInterstitialPromotions');
const interstitialsActions = require('actions/interstitialGeneric');
const interstitialCommercialLegalActions = require('actions/commercialInterstitialsAds');
const fatcaDocumentationActions = require('actions/fatcaDocumentation');
const gdprConsentsActions = require('actions/gdprConsents');
const okConsentsActions = require('gdpr-consents/actions/OKConsents');
const logoutActions = require('actions/logout');

// @components
const { OKLink } = require('commonsComponents/OKLink');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKModal = require('components/commons/OKModal/OKModal');
const modalHeaderImg = require('assets/images/referrals-preview-logo.png');
const { ModalCustom } = require('commonsComponents/modalCustom');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { LIType00 } = require('components/commons/legalInterstitial/LIType00');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKConsentsUpdateButton } = require('gdpr-consents/components/OKConsentsUpdateButton/OKConsentsUpdateButton.js');
const { InterstitialGDPR } = require('okInterstitials/InterstitialGDPR');
const { LoadingSection } =  require('commonsComponents/loadingSection');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @constants
const {
    FIOC_WARNING_DAYS_UNTIL_ACCOUNT_BLOCK,
    FIOC_WARNING_DAYS_UNTIL_OPERATIONS_BLOCK,
    FIOC_WARNING_DAYS_UNTIL_POSITIONS_BLOCK
} = require('constants/fioc');
const {
    ADOBE_NOT_INTERESTED_STATUS_CODE,
    ADOBE_INTERESTED_STATUS_CODE,
    ADOBE_REJECTED_STATUS_CODE,
    ADOBE_PRESENTED_STATUS_CODE
} = require('constants/adobe');
const { ADOBE, INTERESTITIAL_LEGAL_MODAL } = require('constants/flagBasedFeatures');
const {
    COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
    COMMERCIAL_INTERSTITIAL_CLOSE_AND_NEVER_SEE,
    ACTION_EVENT_CLOSE_MODAL,
    COMMERCIAL_INTERSTITIAL_EVENT_CATEGORY,
} = require('constants/tagging');
const TABLET_MAX_WIDTH = 768;
const { OKCONSENTS_POSITIVE_VALUE } = require('constants/consents');
const MORE_THAN_180 = '07'

// @utilities
const {
    PROC_GDPR_INTERSTITIAL,
    PROC_LEGAL_INTERSTITIAL_FIOC,
    recordLink,
    recordPath,
    recordProcess,
    recordCommercialSpaceV2
} = require('utilities/tagging');
const { ADVANCED_INTERSTITIAL_EVENT_ACTION } = require('constants/index');
const { isFlowMigrationAllowed, isItWebViewPlatform } = require( '../../routes/migrationUsersBranchView/utilities/migration.utils' );

class InterstitialGeneric extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmed: false,
            device: this.checkDevice(),
            displayInterstitial: true,
            gdprAdvertisementTermsRead: false,
            isOpen: true,
            showFioc: false,
            noticedPresented: false
        };

        this.buildCommercial = this.buildCommercial.bind(this);
        this.buildModalInterstitial = this.buildModalInterstitial.bind(this);
        this.buildLegal = this.buildLegal.bind(this);
        this.buildFioc = this.buildFioc.bind(this);
        this.buildFiocFatca = this.buildFiocFatca.bind(this);
        this.handleCloseFatcaModal = this.handleCloseFatcaModal.bind(this);
        this.handleGoToEditFatca = this.handleGoToEditFatca.bind(this);
        this.onCheckLegal = this.onCheckLegal.bind(this);
        this.onHandleCloseCommercialInterstitial = this.onHandleCloseCommercialInterstitial.bind(this);
        this.onHandleImageClick = this.onHandleImageClick.bind(this);
        this.onHandleOptOutCommercialInterstitial = this.onHandleOptOutCommercialInterstitial.bind(this);
        this.handleOnClickCommercialOverlay = this.handleOnClickCommercialOverlay.bind(this);
        this.handleAcceptFioc = this.handleAcceptFioc.bind(this);
        this.handleCancelFioc = this.handleCancelFioc.bind(this);
        this.handleAcceptLegal = this.handleAcceptLegal.bind(this);
        this.handleCancelLegal = this.handleCancelLegal.bind(this);
        this.handleRedirectCommercialUrl = this.handleRedirectCommercialUrl.bind(this);
        this.resize = this.resize.bind(this);
        this.checkDevice = this.checkDevice.bind(this);
        this.setLegalModalState = this.setLegalModalState.bind(this);
        this.setCommercialModalState = this.setCommercialModalState.bind(this);
        this.onHandleRef = this.onHandleRef.bind(this);
        this.onGdprAcceptAll = this.onGdprAcceptAll.bind(this);
        this.onGdprChangeValue = this.onGdprChangeValue.bind(this);
        this.onGdprDisclaimerLinkClick = this.onGdprDisclaimerLinkClick.bind(this);
        this.handleGdprUpdateConsents = this.handleGdprUpdateConsents.bind(this);
        this.handleAcceptAllConsents = this.handleAcceptAllConsents.bind(this);
        this.onHandleGdprCloseModal = this.onHandleGdprCloseModal.bind(this);
        this.handleFiocModalShow = this.handleFiocModalShow.bind(this);
        this.handleGdprAdvertisementCheckboxClick = this.handleGdprAdvertisementCheckboxClick.bind(this);
        this.updateState = this.updateState.bind(this);
        this.getIsMigrationRedirect = this.getIsMigrationRedirect.bind(this);
        this.isMigrationWebViewIntersticial = this.isMigrationWebViewIntersticial.bind(this);

        if (window.addEventListener) {
            window.addEventListener('resize', this.resize);
        } else {
            window.attachEvent('onresize', this.resize);
        }

    }

    componentDidMount() {
        const { getTypeInterstitial, immProfile } = this.props;
        const sameTokenInterstitialSession = compareTokenSessionInterstitial();

        if (!sameTokenInterstitialSession) {
            getTypeInterstitial(immProfile.get('originCountry'));
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immInterstitials } = nextProps;
        const { getFiocContent } = this.props;
        const { showFioc } = this.state;
        const immInterstitialsType = immInterstitials.get('type');
        const getFetchingInterstitial = immInterstitials.get('fetching');

        if (immInterstitialsType === 'fioc' && !showFioc && !getFetchingInterstitial) {
            switch (immInterstitialsType) {
                case 'fioc':
                    getFiocContent();
                    break;
                default:
                    break;
            }
            this.setState({
                showFioc: true
            });
        }
    }

    componentDidUpdate() {
        const { immInterstitials, updateInterstitialAdsStatus } = this.props;
        if (this.state.isOpen && !this.state.noticedPresented){
            const propId = immInterstitials.getIn(['content', 'propId']);
            const offerId = immInterstitials.getIn(['content', 'offerId']);
            if (propId && offerId) {
                const offerCode = immInterstitials.getIn(['content', 'id']);
                const locationId = 'C.2.6';
                const proposition = [{propId, status: ADOBE_PRESENTED_STATUS_CODE, locationId, offerId, offerCode}];
                updateInterstitialAdsStatus(proposition);
                this.updateState({
                    noticedPresented: true
                });
            }
        }
    }

    updateState(newState) {
        this.setState(newState);
    }

    // COMMERCIAL functions
    setCommercialModalState() {
        this.setState({
            isOpen: false,
            displayInterstitial: false
        });
    }

    onHandleImageClick(imageUrl, imageNewTab) {
        if (imageUrl) {
            this.handleRedirectCommercialUrl(imageUrl, imageNewTab);
        }
    }

    createCustomTaggingForCommercial(eventAction) {
        const { immFlagBasedFeatures, immInterstitials } = this.props;
        if (immFlagBasedFeatures.get(ADOBE)) {
            const commercialId = immInterstitials.getIn(['content', 'id']);
            const taggingParams = {
                categoriaEvento: COMMERCIAL_INTERSTITIAL_EVENT_CATEGORY + commercialId,
                accionEvento: eventAction,
                tealiumEvent: COMMERCIAL_ADS_CLICK_TEALIUM_EVENT
            }
            recordCommercialSpaceV2(taggingParams);
        }
    }

    handleRedirectCommercialUrl(href, target = null, name = '') {
        const {
            getAdvancedInterstitialPromotions,
            immInterstitials,
            increaseInterstitialShown,
            markInterstitialAsShown,
            setAdvancedInterstialFlag,
            updateInterstitialAdsStatus,
        } = this.props;
        const targetAudience = immInterstitials.getIn(['content', 'clauseId']);
        const nid = immInterstitials.getIn(['content', 'advancedInterstitialContent','relatedPromotion', 'nid']);
        const creativityType = immInterstitials.getIn(['content', 'creativityType']);
        let uri = href;
        let navigateToProfileView = false;
        if(creativityType === 'interstitial_advanced') {
            recordLink(immInterstitials.getIn(['content', 'id']), name);
        }

        if (creativityType === 'interstitial_advanced' && uri.includes('myprofile/edit')) {
            navigateToProfileView = true
        }

        if(!target) {
            markInterstitialAsShown();
            this.setCommercialModalState();
            generateTokenSessionInterstitial();
        }

        increaseInterstitialShown(targetAudience);
        updateTokenUserInterstitial(immInterstitials);
        if (creativityType === 'interstitial_advanced' && nid) {
            setAdvancedInterstialFlag();
            getAdvancedInterstitialPromotions(nid);
        }

        const propId = immInterstitials.getIn(['content', 'propId']);
        const offerId = immInterstitials.getIn(['content', 'offerId']);
        if (propId && offerId) {
            const offerCode = immInterstitials.getIn(['content', 'id']);
            const locationId = 'C.2.6';
            const proposition = [{propId, status: ADOBE_INTERESTED_STATUS_CODE, locationId, offerId, offerCode}];
            updateInterstitialAdsStatus(proposition);
        }

        if (!!name) {
            this.createCustomTaggingForCommercial(name)
        }
        setTimeout(() => {
            if (navigateToProfileView || (__CONTACT_CENTER__ && uri.includes('myprofile/global'))) {
                this.props.history.push(uri);
            } else if (!!target) {
                window.open(uri, target);
            } else {
                if (hasPublicUrl(uri)) {
                    uri = formatRedirectUrl(uri);
                    window.location.href = uri;
                } else if (hasPrivateUrl(uri)) {
                    this.props.history.push(uri);
                } else {
                    window.open(uri, '_blank');
                }
            }
        }, 2000)
    }

    onHandleCloseCommercialInterstitial() {
        this.createCustomTaggingForCommercial(ACTION_EVENT_CLOSE_MODAL)
        const {
            immFlagBasedFeatures,
            immInterstitials,
            increaseInterstitialShown,
            markInterstitialAsShown,
            updateInterstitialAdsStatus,
        } = this.props;
        const targetAudience = immInterstitials.getIn(['content', 'clauseId']);

        markInterstitialAsShown();
        if (immInterstitials.get('type') === 'default' || !immFlagBasedFeatures.get(ADOBE)) {
            increaseInterstitialShown(targetAudience);
        }
        this.setCommercialModalState();
        generateTokenSessionInterstitial();
        //updateTokenUserInterstitial(immInterstitials);

        const propId = immInterstitials.getIn(['content', 'propId']);
        const offerId = immInterstitials.getIn(['content', 'offerId']);
        if (propId && offerId) {
            const offerCode = immInterstitials.getIn(['content', 'id']);
            const locationId = 'C.2.6';
            const proposition = [{propId, status: ADOBE_NOT_INTERESTED_STATUS_CODE, locationId, offerId, offerCode}];
            updateInterstitialAdsStatus(proposition);
        }
    }

    onHandleOptOutCommercialInterstitial() {
        this.createCustomTaggingForCommercial(COMMERCIAL_INTERSTITIAL_CLOSE_AND_NEVER_SEE)

        const {
            dontShowInterstitialAgain,
            immFlagBasedFeatures,
            immInterstitials,
            markInterstitialAsShown,
            updateInterstitialAdsStatus,
        } = this.props;
        const targetAudience = immInterstitials.getIn(['content', 'clauseId']);
        markInterstitialAsShown();
        if (immInterstitials.get('type') === 'default' || !immFlagBasedFeatures.get(ADOBE)) {
            dontShowInterstitialAgain(targetAudience);
        }
        this.setCommercialModalState();
        generateTokenSessionInterstitial();
        //updateTokenUserInterstitial(immInterstitials);

        const propId = immInterstitials.getIn(['content', 'propId']);
        const offerId = immInterstitials.getIn(['content', 'offerId']);
        if (propId && offerId) {
            const offerCode = immInterstitials.getIn(['content', 'id']);
            const locationId = 'C.2.6';
            const proposition = [{propId, status: ADOBE_REJECTED_STATUS_CODE, locationId, offerId, offerCode}];
            updateInterstitialAdsStatus(proposition);
        }
    }

    handleOnClickCommercialOverlay(e) {
        const overlayClassName = get(e, 'target.className', '') || '';
        if (overlayClassName === 'interstitial-generic__commercial-container') {
            this.onHandleCloseCommercialInterstitial();
        }
    }

    /**
     * Manual management of interstitial links
     */
    onHandleRef(e) {
        if (e) {
            const element = ReactDOM.findDOMNode(e);
            if (element) {
                const anchors = element.getElementsByTagName('a');
                if (anchors.length > 0) {
                    const optOut = element.querySelector('.interstitial-optional-out');
                    Array.from(anchors).forEach((anchor) => {
                        const href = anchor.href;
                        const target = anchor.target;
                        const name = anchor.text;
                        anchor.removeAttribute('href');
                        anchor.removeAttribute('target');
                        anchor.removeEventListener('click', () => { });
                        if (!!optOut && optOut.contains(anchor) && anchor.className === 'optional-out') {
                            anchor.addEventListener('click', this.onHandleOptOutCommercialInterstitial);
                        }
                        else if (href) {
                            anchor.addEventListener('click', () => {
                                this.handleRedirectCommercialUrl(href, target, name);
                            });
                        }
                    });
                }
            }
        }
    }

    buildCommercial() {
        const { immInterstitials, immProfile, immProfileShippingAddress, history } = this.props;
        const { device, isOpen, displayInterstitial } = this.state;
        const isDesktop = device === 'desktop';
        const layout = immInterstitials.getIn(['content', 'fieldLayoutType']);
        let commercialInterstitial;
        let hasLayaout = true;
        let content;
        switch (layout) {
            case 'image_big':
                commercialInterstitial = buildTemplateCommercialA(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, isDesktop, this.onHandleRef);
                break;
            case 'image_big_left_text':
            case 'image_big_right_text':
                commercialInterstitial = buildTemplateCommercialB(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, layout, isDesktop, this.onHandleRef);
                break;
            case "image_medium_left_text":
            case "image_medium_right_text":
                commercialInterstitial = buildTemplateCommercialC(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, layout, isDesktop, this.onHandleRef);
                break;
            case "advanced_image_medium_left_text":
                recordLink(immInterstitials.getIn(['content', 'id']), ADVANCED_INTERSTITIAL_EVENT_ACTION);
                commercialInterstitial = buildTemplateCommercialAdvance(immInterstitials, immProfile, immProfileShippingAddress, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, layout, isDesktop, this.onHandleRef, history);
                break;
            case 'image_small_bottom_text':
            case 'image_small_top_text':
                commercialInterstitial = buildTemplateCommercialD(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, layout, isDesktop, this.onHandleRef);
                break;
            case 'two_images_big':
                commercialInterstitial = buildTemplateCommercialF(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, isDesktop, this.onHandleRef);
                break;
            case 'three_image_big':
                commercialInterstitial = buildTemplateCommercialE(immInterstitials, this.onHandleImageClick, this.onHandleCloseCommercialInterstitial, isDesktop, this.onHandleRef);
                break;
            case 'image_big_box':
                commercialInterstitial = buildTemplateCommercialG(immInterstitials, this.onHandleCloseCommercialInterstitial, isDesktop, this.onHandleRef);
                break;
            default:
                hasLayaout = false;
                break;
        }

        if (isOpen && displayInterstitial && hasLayaout) {
            content = (
                <div
                    className="interstitial-generic__commercial-container"
                    onClick={this.handleOnClickCommercialOverlay}
                >
                    <div className="interstitial-generic__commercial-modal">
                        {commercialInterstitial}
                    </div>
                </div>
            )
        }

        return content;
    }

    // LEGAL functions

    setLegalModalState() {
        this.setState({
            isOpen: false,
            confirmed: false
        });
    }

    handleAcceptLegal() {
        const { immInterstitials, confirmInterstitialClause, immFlagBasedFeatures, handleAcceptLegalAction } = this.props;
        const interstitialType = immInterstitials.getIn(['content','interstitialType']);
        const interstitialID = immInterstitials.getIn(['content','id']);
        if(!!interstitialType && interstitialType === "legal" && immFlagBasedFeatures.get(INTERESTITIAL_LEGAL_MODAL)){
            handleAcceptLegalAction(interstitialID)
            this.setLegalModalState();
        }
        else {
        const clauseId = immInterstitials.getIn(['content', 'clauseId']);
        const contentId = immInterstitials.getIn(['content', 'id']);
        confirmInterstitialClause(clauseId, contentId);
        generateTokenSessionInterstitial();
        this.setLegalModalState();
        }
    }

    handleCancelLegal() {
        const { immInterstitials, handleLogout, markInterstitialAsShown } = this.props;
        const mandatory = immInterstitials.getIn(['content', 'mandatory']);
        if (mandatory) {
            handleLogout();
        } else {
            markInterstitialAsShown();
            this.setLegalModalState();
        }
        updateTokenUserInterstitial(immInterstitials) // con fecha de caducidad baja;
    }

    onCheckLegal(event) {
        this.setState({
            confirmed: typeof event === 'boolean' ? event : event.target.checked
        });
    }

    buildLegal(scroll = false) {
        const { immInterstitials, immProfile } = this.props;
        const { isOpen, confirmed } = this.state;
        const interstitialSubType = immInterstitials.getIn(['content','interstitialSubType']);
        const userName = toCamelCase(immProfile.get('nombreCliente').trim());
        const titleText = __CONTACT_CENTER__? `interstitialLegal-modalTitleCC_${interstitialSubType}`:`interstitialLegal-modalTitle_${interstitialSubType}`;
        const message = __CONTACT_CENTER__? formatText(`interstitialLegal-modalContentCC_${interstitialSubType}`):interstitialSubType ==='' ? immInterstitials.getIn(['content', 'body']):formatText(`interstitialLegal-modalContent_${interstitialSubType}`)
        const title = __CONTACT_CENTER__? <FormattedText value={titleText} injectedStrings={[userName]} />:interstitialSubType ==='' ? immInterstitials.getIn(['content', 'title']): <FormattedText value={titleText} injectedStrings={[userName]} />;
        const disclaimerText = `interstitialLegal-modalDisclaimerText_${interstitialSubType}`;
        const pdfLinkText = formatText(`interstitialLegal-modalPDFLinkText_${interstitialSubType}`);
        const pdfURL = formatText(`interstitialLegal-modalPDFLink_${interstitialSubType}`);
        const pdfLink = pdfLinkText && (
                            <OKLink
                                modifier="emphasize"
                                to={pdfURL}
                                id={'pdfLinkText'}
                                target="_blank"
                            >
                                {pdfLinkText}
                            </OKLink>
                        );

        const footerLinkWithText = pdfLink && (
                                    <FormattedTextWithComponents
                                        value={disclaimerText}
                                        injectedComponents={[pdfLink]}
                                    />
                                );
        const body = <HTMLSafeInjector message={message} />;
        const modalContent = (
            <LIType00
                title={title}
                body={body}
                confirmed={confirmed}
                scrollDown={scroll}
                checkboxText={__CONTACT_CENTER__? null : formatText('interstitialLegal-acceptCheck')}
                handleCheck={this.onCheckLegal}
            />
        );

        return (
            scroll ? <OKModal
                content={modalContent}
                footerType={__CONTACT_CENTER__? "default" : "navigation"}
                isOpen={isOpen}
                onCloseCallback={this.handleCancelLegal}
                onPrimaryButtonClick={this.handleAcceptLegal}
                primaryButtonDisabled={!confirmed}
                primaryButtonText={__CONTACT_CENTER__? '' : "common-accept"}
                shouldCloseOnOverlayClick={false}
                size="large"
                footerLinkWithText={__CONTACT_CENTER__? null : footerLinkWithText}
                title={title}
                overlayClassName={'ok-modal-interstitial-overlay'}
            /> : <OKModal
                content={modalContent}
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeaderImg}
                headerImageWidth="250px"
                headerType="image"
                isOpen={isOpen}
                onCloseCallback={this.handleCancelLegal}
                onPrimaryButtonClick={this.handleAcceptLegal}
                onSecondaryButtonClick={this.handleCancelLegal}
                primaryButtonDisabled={!confirmed}
                primaryButtonText="common-accept"
                shouldCloseOnOverlayClick={false}
                secondaryButtonText="common-cancel"
                size="large"
                title={title}
                overlayClassName={'ok-modal-interstitial-overlay'}
            />
        );
    }

    // FIOC functions
    getUtagPageNameForFioc() {
        const { immInterstitials } = this.props;
        const messageCodeFioc = immInterstitials.getIn(['content', 'codMensaje']);
        const daysString = {
            '01': 'entre 0 y 30',
            '02': 'entre 30 y 60',
            '03': 'entre 60 y 90',
            '04': 'entre 90 y 120',
            '05': 'entre 120 y 150',
            '06': 'entre 150 y 180',
            '07': 'mas de 180',
        };
        return PROC_LEGAL_INTERSTITIAL_FIOC.replace('%s', daysString[messageCodeFioc]);
    }

    getUTagCustomTagDataForFioc(eventTag) {
        return {
            eventCategory: 'actualizacion fioc',
            eventName: 'inicio',
            eventTag
        };
    }

    handleCancelFioc() {
        const { immInterstitials, handleLogout, markInterstitialAsShown } = this.props;
        const mandatory = immInterstitials.getIn(['content', 'mandatory']);
        window.removeEventListener('mousedown', this.checkComponent);

        if (immInterstitials.get('type') === 'fioc') {
            recordProcess(
                this.getUtagPageNameForFioc(),
                null,
                this.getUTagCustomTagDataForFioc('recordar mas tarde') // does not require translation
            );
        }
        if (mandatory) {
            handleLogout();
        } else {
            markInterstitialAsShown();
            this.setState({
                isOpen: false,
            });
        }
        generateTokenSessionInterstitial();
        updateTokenUserInterstitial(immInterstitials);
    }

    handleAcceptFioc() {
        const { markInterstitialAsShown, immInterstitials } = this.props;
        let url;

        this.setState({
            isOpen: false,
        });

        if (immInterstitials.getIn(['content', 'flagFioc']) === "1") {
            url = "/myprofile/fioc";
        } else if (immInterstitials.getIn(['content', 'flagDocumentacion']) === "1") {
            url = "/myprofile/edit/fioc";
        } else {
            url = '/myprofile/edit';
        }
        recordProcess(
            this.getUtagPageNameForFioc(),
            null,
            this.getUTagCustomTagDataForFioc('actualizar documento') // does not require translation
        );

        generateTokenSessionInterstitial();
        markInterstitialAsShown();
        this.props.history.push(url);
    }

    handleGoToEditFatca() {
        const fatcaPath = "/myprofile/fatca";

        this.setState({
            isOpen: false,
        });

        this.props.history.push(fatcaPath);
        this.handleCloseFatcaModal()
    }

    handleCloseFatcaModal() {
        const { immInterstitials } = this.props;

        this.setState({
            isOpen: false,
        });

        generateTokenSessionInterstitial();
        updateTokenUserInterstitial(immInterstitials);
        this.props.fatcaCloseModal();
    }

    buildFiocFatca() {
        const { fatcaOpenModal } = this.props;
        const { isOpen } = this.state;
        const modalHeader = <i className="fatca-modal__icon" />;
        const modalDescription = (
            <React.Fragment>
                <p><FormattedText value="fatca-modalText1" /></p>
                <p><FormattedText value="fatca-modalText2" /></p>
            </React.Fragment>
        );

        fatcaOpenModal();
        return (
            <OKModal
                description={modalDescription}
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeader}
                headerType="custom"
                isOpen={isOpen}
                onCloseCallback={this.handleCloseFatcaModal}
                onPrimaryButtonClick={this.handleGoToEditFatca}
                onSecondaryButtonClick={this.handleCloseFatcaModal}
                primaryButtonText="fatca-modalAccept"
                shouldCloseOnOverlayClick={false}
                secondaryButtonText="fatca-modalCancel"
                size="large"
                title="fatca-modalTitle"
            />
        );
    }

    handleFiocModalShow() {
        recordPath(this.getUtagPageNameForFioc());
    }

    getIsMigrationRedirect() {
        const { immProfile, immMigration } = this.props;
        return immProfile.get('originCountry')
            && immProfile.get('originCountry') === 'DE'
            && immMigration.getIn(['fetched'])
            && immMigration.getIn(['status'])
            && isFlowMigrationAllowed(immMigration.getIn(['status']));
    }


    isMigrationWebViewIntersticial() {
        const { immInterstitials, immProfile } = this.props;
        return immProfile.get('originCountry')
            && immProfile.get('originCountry') === 'DE'
            && immInterstitials.getIn(['content', 'fieldLayoutType']) === "image_medium_right_text"
            && immInterstitials.getIn(['content', 'layoutFilteredContent','firstInterstitial', 'cta', 'ctaPrimaryUrl'])?.includes('myprofile/migration')
            && isItWebViewPlatform();
    }

    buildFioc() {
        const { immInterstitials, immScreen } = this.props;
        const { isOpen } = this.state;
        
        if (!immScreen.get('isDesktop') && this.getIsMigrationRedirect()) return null;
        if (!immScreen.get('isDesktop')) return this.handleAcceptFioc();
        const immInterstitialsContent = immInterstitials.get('content');
        const fechaAltaExp = immInterstitialsContent.get('fechaAltaExp')
        const messageCodeFioc = immInterstitialsContent.get('codMensaje');
        const name = toCamelCase(this.props.immProfile.get('nombreCliente').trim());
        const titleLabel = (!__CONTACT_CENTER__ && (messageCodeFioc === MORE_THAN_180)) ? 'urgentTitle' : 'title';
        const title = <FormattedText value={'fiocMessages-' + titleLabel} injectedStrings={[name]} />;
        const icon = 'error';
        let remainingDaysUtilBlock;
        let totalDaysForCountdown = FIOC_WARNING_DAYS_UNTIL_ACCOUNT_BLOCK;

        const expirationDate = moment(fechaAltaExp, 'DD/MM/YYYY');
        const daysSinceExpiration = moment().diff(expirationDate, 'days');

        if (messageCodeFioc === '03') {
            totalDaysForCountdown = FIOC_WARNING_DAYS_UNTIL_OPERATIONS_BLOCK;
        }

        if (messageCodeFioc === MORE_THAN_180) {
            totalDaysForCountdown = FIOC_WARNING_DAYS_UNTIL_POSITIONS_BLOCK;
        }

        remainingDaysUtilBlock = totalDaysForCountdown - daysSinceExpiration;

        let bodyTranslationLabel = `_EC${messageCodeFioc}`;
        if (messageCodeFioc === MORE_THAN_180 && remainingDaysUtilBlock < 0) {
            bodyTranslationLabel += 'B';
        }

        bodyTranslationLabel += `_FF${immInterstitialsContent.get('flagFioc')}_FD${immInterstitialsContent.get('flagDocumentacion')}`;
        const body = (
            <FormattedText
                injectedStrings={!__CONTACT_CENTER__ ? [remainingDaysUtilBlock] : [name,remainingDaysUtilBlock]}
                value={'fiocMessages-interstitialMsg' + bodyTranslationLabel}
            />
        );
        const modalContent = (
            <LIType00
                body={body}
                iconStyle={icon}
                modifier={'fioc'}
            />
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeaderImg}
                headerImageWidth="250px"
                headerType="image"
                isOpen={isOpen}
                onAfterOpen={this.handleFiocModalShow}
                onCloseCallback={this.handleCancelFioc}
                onPrimaryButtonClick={this.handleAcceptFioc}
                onSecondaryButtonClick={this.handleCancelFioc}
                primaryButtonText="fiocMessages-acceptButton"
                shouldCloseOnOverlayClick={false}
                secondaryButtonText="fiocMessages-cancelButton"
                size="large"
                title={title}
            />
        );
    }

    // GDPR functions

    handleGdprUpdateConsents() {
        const { immInterstitials, dontShowInterstitialAgain } = this.props;
        const clauseId = immInterstitials.getIn(['content', 'clauseId']) + '_promotion-accepted';
        let results = '';
        this.props.immConsentsGdpr.get('consents').forEach(immConsent => {
            const id = immConsent.getIn(['consentCell', 'id']);
            const status = immConsent.get('status');
            results += `${id}:${status}|`;
        });
        results = results.substring(0, results.length - 1);
        recordLink(PROC_GDPR_INTERSTITIAL, 'Confirmar', results);
        if (this.state.gdprAdvertisementTermsRead) {
            dontShowInterstitialAgain(clauseId);
        }
        this.props.updateConsents()
            .then(this.onHandleOptOutCommercialInterstitial)
            .catch(this.onHandleCloseCommercialInterstitial);
    }

    onHandleGdprCloseModal() {
        recordLink(PROC_GDPR_INTERSTITIAL, 'cerrar modal');
        this.onHandleCloseCommercialInterstitial();
    }

    onGdprAcceptAll(value) {
        recordGdprClauseInteraction(value, PROC_GDPR_INTERSTITIAL)
    }

    onGdprChangeValue(id, value) {
        recordGdprClauseInteraction(value, PROC_GDPR_INTERSTITIAL, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const linkElement = event.target;
        if (linkElement) {
            recordLink(PROC_GDPR_INTERSTITIAL, get(linkElement, 'attributes.data-title.value', ''));
        }
    }

    handleGdprAdvertisementCheckboxClick(){
        this.setState(prevState => ({
            gdprAdvertisementTermsRead: !prevState.gdprAdvertisementTermsRead
        }));
    }

    handleAdvertisementLinkClick(event) {
        const linkElement = event.target;
        if (linkElement) {
            recordLink(PROC_GDPR_INTERSTITIAL, 'Bases del sorteo');
        }
    }

    handleGDPRModalShow() {
        recordPath(PROC_GDPR_INTERSTITIAL);
    }

    handleAcceptAllConsents() {
        recordGdprClauseInteraction(OKCONSENTS_POSITIVE_VALUE);
        this.props.updateAllConsents(OKCONSENTS_POSITIVE_VALUE);
        this.handleGdprUpdateConsents();
    }

    buildGDPRAdvertisement() {
        const advertisementLinkURL = formatText('gdpr-gdpr_interstitialPromoLinkUrl');
        const checkboxLabel = (
            <React.Fragment>
                <FormattedText value="gdpr-gdpr_interstitialPromoText1" />
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    onClick={this.handleAdvertisementLinkClick}
                    target="_blank"
                    to={advertisementLinkURL}
                >
                    <FormattedText value="gdpr-gdpr_interstitialPromoLinkText" />
                </OKLink>
                <FormattedText value="gdpr-gdpr_interstitialPromoText2" />
            </React.Fragment>
        );

        return (
            <OKCheckbox
                idName="GDPRAdvertisementTermsRead"
                label={checkboxLabel}
                value={this.state.gdprAdvertisementTermsRead}
                onChange={this.handleGdprAdvertisementCheckboxClick}
            />
        );
    }

    buildGDPR() {
        const { isOpen } = this.state;
        const { immConsentsGdpr, immProfile } = this.props;
        const immConsents = immConsentsGdpr.get('consents');
        const clientName = toCamelCase(trim(immProfile.get('nombreCliente')).toLowerCase());
        const interstitialTitle = <FormattedText value="gdpr-interstitialTitleWithName" injectedStrings={[clientName]} />;
        const advertisementTitle = <FormattedText value="gdpr-interstitialPromoTitle" />;
        const advertisementContent = this.buildGDPRAdvertisement();

        let confirmBtnTranslationKey = 'common-confirm';
        let onClick = this.handleGdprUpdateConsents;

        // If the user didn't start editing, we show "Accept all" button
        if (!immConsentsGdpr.get('consentsEditInProgress')) {
            confirmBtnTranslationKey = immConsentsGdpr.getIn(['selectAll', 'poEditor']);
            onClick = this.handleAcceptAllConsents;
        }

        const acceptButton = (
            <OKConsentsUpdateButton
                textTranslationKey={confirmBtnTranslationKey}
                onClick={onClick}
            />
        );

        // Here we check if we need to show the warning. The warning will show if
        // there is at least one rejected clause.
        const showWarning = immConsents.some(consent => consent.get('status') === 'NOT_ACCEPTED');

        return (
            <ModalCustom
                isOpen={isOpen}
                onShow={this.handleGDPRModalShow}
                scrollable={false}
                overlayClassName="interstitial-gdpr__overlay"
                extraClass="interstitial-gdpr interstitial-gdpr--scrollable"
            >
                <InterstitialGDPR
                    acceptButton={acceptButton}
                    advertisementTitle={advertisementTitle}
                    advertisementContent={advertisementContent}
                    handleOnClose={this.onHandleGdprCloseModal}
                    interstitialTitle={interstitialTitle}
                    hasWarning={showWarning}
                    warningMessage={<FormattedText value="gdpr-interstitialWarnMessage" />}
                >
                    <OKConsents
                        placementId="interstitial"
                        handleAcceptAll={this.onGdprAcceptAll}
                        handleChangeValue={this.onGdprChangeValue}
                        handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
                        quickAcceptMode={true}
                        showChannels={false}
                    />
                </InterstitialGDPR>
            </ModalCustom>
        )
    }

    // Render functions
    buildModalInterstitial() {
        const { immInterstitials, immFlagBasedFeatures, immScreen } = this.props;
        const createModal = immInterstitials.size === 0;
        const interstitialType = immInterstitials.get('type');
        const legalInterstitialType = immInterstitials.getIn(['content','interstitialType']);
        const isFetching = immInterstitials.get('fetching');
        const sameTokenInterstitialSession = compareTokenSessionInterstitial();
        let immInterstitialsModal;

        if (isFetching) {
            immInterstitialsModal =  (
                <div className={`interstitial-generic__commercial-container ${!immScreen.get('isDesktop') ? 'interstitial-generic__commercial-container-mobile' : ''}`}>
                    <div className="interstitial-generic__commercial-modal">
                        <LoadingSection />
                    </div>
                </div>
            );
        } else if (immInterstitials.get('content')) {
            let buildModal = interstitialType === 'fioc' ? immInterstitials.getIn(['content', 'codMensaje']) : immInterstitials.get('content').size !== 0;
            if (buildModal !== undefined && buildModal && !sameTokenInterstitialSession) {
                let hasToken = hasTokenInterstitial(immInterstitials);
                if (immInterstitials !== undefined && !createModal && !hasToken) {
                    const interstitialHasBeenShown = immInterstitials.get('hasBeenShown');
                    // const emptyNodes = immInterstitials.getIn(['content', 'nodes']).size !== 0;
                    if (!interstitialHasBeenShown && !!immInterstitials.get('fetched')) {
                        if (interstitialType === 'fioc') {
                            immInterstitialsModal = this.buildFioc();
                        } else if (interstitialType === 'commercial' || interstitialType === 'default') {
                            if(interstitialType === 'commercial' && this.isMigrationWebViewIntersticial()) {
                                return null;
                            } else {
                                const creativityType = immInterstitials.getIn(['content', 'creativityType']);
                                if (__CONTACT_CENTER__ && creativityType !== 'interstitial_advanced') {
                                    return immInterstitialsModal;
                                }
                                immInterstitialsModal = this.buildCommercial();
                            }
                        } else if (interstitialType === 'cms') {
                            immInterstitialsModal = this.buildLegal();
                        } else if ((!!legalInterstitialType && legalInterstitialType === "legal" ) && immFlagBasedFeatures.get(INTERESTITIAL_LEGAL_MODAL)){
                            immInterstitialsModal = this.buildLegal(true);
                        } else if (interstitialType === 'gdpr') {
                            immInterstitialsModal = this.buildGDPR();
                        } else if (interstitialType === 'fatca') {
                            immInterstitialsModal = this.buildFiocFatca();
                        }
                    }
                }
            }
        }
        return immInterstitialsModal;
    }

    checkDevice() {
        const screenWidth = window.screen && window.innerWidth || 0;
        return (screenWidth > TABLET_MAX_WIDTH) ? 'desktop' : 'tablet';
    }

    resize() {
        this.setState({
            device: this.checkDevice()
        })
    }

    render() {
        const interstitial = this.buildModalInterstitial();
        return (
            <div>
                {interstitial}
            </div>
        )
    }

}

InterstitialGeneric.propTypes = {
    getInterstitials: PropTypes.func,
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object,
    immInterstitials: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immMigration: PropTypes.object,
    immProfile: PropTypes.object,
    immProfileShippingAddress: PropTypes.object,
    immConsentsGdpr: PropTypes.object,
    markInterstitialAsShown: PropTypes.func,
    dontShowInterstitialAgain: PropTypes.func,
    increaseInterstitialShown: PropTypes.func,
    getAdvancedInterstitialPromotions: PropTypes.func,
    getTypeInterstitial: PropTypes.func,
    getCommercialContent: PropTypes.func,
    getFiocContent: PropTypes.func,
    getLegalContent: PropTypes.func,
    confirmInterstitialClause: PropTypes.func,
    handleAcceptLegalAction: PropTypes.func,
    handleLogout: PropTypes.func,
    fatcaOpenModal: PropTypes.func,
    fatcaDocumentation: PropTypes.object,
    fatcaCloseModal: PropTypes.func,
    setAdvancedInterstialFlag: PropTypes.func,
    updateAllConsents: PropTypes.func,
    updateConsents: PropTypes.func,
    updateInterstitialAdsStatus: PropTypes.func,
};

InterstitialGeneric.defaultProps = {
    getInterstitials: () => { },
    fatcaOpenModal: () => { },
    fatcaCloseModal: () => { },
    immGlobalPosition: {},
    immInterstitials: {},
    immFlagBasedFeatures: {},
    immMigration: {},
    immProfile: {},
    markInterstitialAsShown: () => { },
    dontShowInterstitialAgain: () => { },
    increaseInterstitialShown: () => { },
    getTypeInterstitial: () => { },
    getCommercialContent: () => { },
    getLegalContent: () => { },
    confirmInterstitialClause: () => { },
    handleAcceptLegalAction: () => { },
    handleLogout: () => { },
}

module.exports = InterstitialGeneric;

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInterstitials: state.interstitialGeneric,
        immMigration: state.migration,
        immProfile: state.profile,
        immProfileShippingAddress: state.myProfileShippingAddress,
        fatcaDocumentation: state.fatcaDocumentation,
        immConsentsGdpr: state.gdprConsents,
        immScreen: state.screen,       
    }), {
        handleLogout: logoutActions.handleLogout,
        markInterstitialAsShown: interstitialsActions.markInterstitialAsShown,
        confirmInterstitialClause: interstitialsActions.confirmInterstitialClause,
        handleAcceptLegalAction: interstitialsActions.handleAcceptLegalAction,
        getAdvancedInterstitialPromotions: advancedInterstitialPromotionActions.getAdvancedInterstitialPromotions,
        getTypeInterstitial: interstitialsActions.getTypeInterstitial,
        getCommercialContent: interstitialsActions.getCommercialContent,
        getFiocContent: interstitialsActions.getFiocContent,
        getLegalContent: interstitialsActions.getLegalContent,
        dontShowInterstitialAgain: interstitialCommercialLegalActions.dontShowInterstitialAgain,
        increaseInterstitialShown: interstitialCommercialLegalActions.increaseInterstitialShown,
        fatcaOpenModal: fatcaDocumentationActions.fatcaOpenModal,
        fatcaCloseModal: fatcaDocumentationActions.fatcaCloseModal,
        setAdvancedInterstialFlag: interstitialsActions.setAdvancedInterstialFlag,
        updateAllConsents: okConsentsActions.updateAllConsentsStatus,
        updateConsents: gdprConsentsActions.updateConsents,
        updateInterstitialAdsStatus: interstitialsActions.updateInterstitialAdsStatus,
    }
)(withRouter(InterstitialGeneric));
